import CommonModal from "../../../../../../core/common/commonModal";
import LeaveForm from "../../../../../../core/common/leaveForm";
import { DAY_TYPES } from "../utils/leaveConstants";

interface AddLeaveModalProps {
    visible: boolean;
    leaveTypes: any[];
    leaveBalances: any[];
    onClose: () => void;
    onSubmit: (values: any) => Promise<void>;
}

const AddLeaveModal: React.FC<AddLeaveModalProps> = ({
    visible,
    leaveTypes,
    leaveBalances,
    onClose,
    onSubmit,
}) => {
    return (
        <CommonModal
            id="add_leaves_modal"
            title="Add Leave"
            visible={visible}
            onClose={onClose}
        >
            <LeaveForm
                mode="add"
                leaveTypes={leaveTypes}
                dayTypes={DAY_TYPES}
                leaveBalances={leaveBalances}
                onSubmit={onSubmit}
                onCancel={onClose}
            />
        </CommonModal>
    );
};

export default AddLeaveModal;
